import styled, { createGlobalStyle } from 'styled-components';
import backgroundImg from '../assets/background.jpeg';

export default createGlobalStyle`
  :root {
    /* Brand — amber stays the real primary action color of the app */
    --primary: #FFBC03;
    --primary-hover: #E0A500;
    --primary-foreground: #1C1917;
    --primary-soft: #FFE8A3;

    /* Neutrals */
    --stone-50: #FAFAF9;
    --stone-100: #F5F5F4;
    --stone-200: #E7E5E4;
    --stone-300: #D6D3D1;
    --stone-400: #A8A29E;
    --stone-500: #78716C;
    --stone-600: #57534E;
    --stone-700: #44403C;
    --stone-800: #292524;
    --stone-900: #1C1917;

    /* Semantic aliases */
    --background: #FFFFFF;
    --foreground: var(--stone-900);
    --card: #FFFFFF;
    --card-foreground: var(--stone-900);
    --muted: var(--stone-100);
    --muted-foreground: var(--stone-500);
    --border: var(--stone-200);
    --input: var(--stone-200);
    --ring: var(--primary);

    /* Feedback */
    --feedback-success: #388F46;
    --feedback-warning: #FFC107;
    --feedback-danger: #FF5A60;
    --feedback-info: #4263EB;
    --info: #004EFF;

    /* Versões escuras dos tons de feedback, para quando eles carregam texto:
       como fundo de faixa com texto branco, ou como cor de texto sobre um
       fundo claro. Os tons acima são vivos demais para isso — branco sobre o
       --feedback-warning dá 1,7:1 de contraste, praticamente ilegível. Estes
       ficam em torno de 5:1 nos dois usos. */
    --feedback-success-strong: #256E33;
    --feedback-warning-strong: #8D6100;
    --feedback-danger-strong: #B3261E;

    --alert-fg: #2C3F9E;
    --alert-bg: #EEF1FD;
    --alert-border: #C6D0F7;
    --alert-icon: #4263EB;

    /* Radii */
    --radius-xs: 0.125rem;
    --radius-sm: 0.25rem;
    --radius-md: 0.375rem;
    --radius-lg: 0.5rem;
    --radius-full: 9999px;

    /* Spacing scale */
    --space-1: 0.25rem;
    --space-2: 0.5rem;
    --space-3: 0.75rem;
    --space-4: 1rem;
    --space-5: 1.25rem;
    --space-6: 1.5rem;
    --space-8: 2rem;

    /* Shadows — subtle, borders do most of the work */
    --shadow-xs: 0 1px 2px 0 rgb(0 0 0 / 0.05);
    --shadow-sm: 0 1px 4px 0 rgb(0 0 0 / 0.08), 0 1px 2px -1px rgb(0 0 0 / 0.06);
    --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.10), 0 2px 4px -2px rgb(0 0 0 / 0.06);
    --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.10), 0 4px 6px -4px rgb(0 0 0 / 0.05);

    /* Typography */
    --font-sans: 'Roboto', system-ui, -apple-system, 'Helvetica Neue', Arial, sans-serif;
    --font-mono: 'JetBrains Mono', ui-monospace, 'SFMono-Regular', Menlo, monospace;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: 0;
  }

  html {
    height: -webkit-fill-available;
  }

  body {
    height: 100%;
    min-height: -webkit-fill-available;
    background: url(${backgroundImg}) no-repeat;
    background-size: cover;
    color: #626262;
    -webkit-font-smoothing: antialiased;
  }

  body, input, button {
    font-family: var(--font-sans);
    font-size: 16px;
  }

  h1, h2, h3 h4, h5, h6, strong {
    font-weight: 500;
  }

  button {
    cursor: pointer;
  }

  /* O reCAPTCHA invisível injeta o selo logo onde o componente está montado
     (dentro do card de login). Fixamos no canto da viewport, acima do rodapé,
     que é onde o Google recomenda que ele fique.

     O selo tem 256px e o Google o "recolhe" deslocando-o para fora da tela
     (right: -186px), deixando só a coluna de 70px do ícone visível, e traz de
     volta no hover. Como aqui as regras precisam de !important para vencer o
     CSS injetado pelo Google, os dois estados são declarados explicitamente —
     fixar apenas o right em 0 deixava o selo permanentemente aberto. */
  .grecaptcha-badge {
    position: fixed !important;
    bottom: 3.5rem !important;
    right: -186px !important;
    transition: right 0.3s ease !important;
    z-index: 20;
    box-shadow: 0 2px 10px rgba(18, 18, 18, 0.18) !important;
  }

  .grecaptcha-badge:hover,
  .grecaptcha-badge:focus-within {
    right: 0 !important;
  }

  @media(max-width: 1080px) {
      html {
          font-size: 93.75%;
      }
    }
    @media(max-width: 720px) {
      html {
          font-size: 87.5%;
      }
    }
`;

export const Title = styled.h1`
  font-size: 1.5rem;
  line-height: 2rem;
  width: 100%;
  text-align: center;
  font-weight: bold;
  margin-bottom: 1rem;

  @media (max-width: 600px) {
    font-size: 1rem;
  }
`;

export const MobileCam = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;

  > section {
    width: 100%;
    height: 100%;
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;

    > section {
      width: 100%;
      height: 300px;

      section {
        height: 100%;

        p {
          margin: 0;
        }
      }
    }
  }

  button {
    margin-top: 1rem;
  }
`;
